import "./Section.css";

// Section title with its function-key badge (F1, F2 …) and an optional intro.
const SectionHead = ({ fkey, title, intro }) => (
  <div className="section__head">
    <div className="section__title-row">
      <span className="fkey" aria-hidden="true">{fkey}</span>
      <h2 className="section__title">{title}</h2>
    </div>
    {intro && <p className="section__intro">{intro}</p>}
  </div>
);

export default SectionHead;
